export const APP_CONFIG = {
  name: "Convert XML to XLS",
  supportEmail: "smallpdfkenya@gmail.com",
  maxEmailChanges: 2,
};

export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyBE4jvTTaRNKN0iXNd_B_AP4Xrwl4EXqYs",
  authDomain: "dedupeone.firebaseapp.com",
  databaseURL: "https://dedupeone-default-rtdb.firebaseio.com",
  projectId: "dedupeone",
  storageBucket: "dedupeone.appspot.com",
  messagingSenderId: "939637555230",
  appId: "1:939637555230:web:615611b6fa04962e56ae0f",
  measurementId: "G-JDNL35CYD1",
};

export const PAYMENT_CONFIG = {
  paypalSubscribeUrl:
    "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-8SV522455E1111508NKP4P6A",
  firestoreDocPath: "payments",
  firestoreDocId: "XmlForExcel",
  trialMonths: 1,
};

export const STORAGE_KEYS = {
  email: "email",
  trialEndDate: "trialEndDate",
  lastRegisteredEmail: "lastRegisteredEmail",
  emailChangeCount: "emailChangeCount",
  subscriptionCheckedForDate: "scfd",
  subscriptionStatus: "ss",
};
